import React from "react";
import StatusPage from "./StatusPage";

/**
 * Cíl odkazu po resetu hesla (continue URL /password-reset-complete,
 * nastavuje auth.ts resetPassword). Titulek hlavičky dodává AppShell.
 */
const PasswordResetComplete: React.FC = () => (
  <StatusPage
    icon="bi-shield-check"
    tone="success"
    title="Heslo bylo změněno"
    text="Nyní se můžete přihlásit pomocí nového hesla."
    action={{ label: "Přihlásit se", to: "/login" }}
  />
);

export default PasswordResetComplete;
